import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    status: 'index',
    fullHeight: 0,
    urlData: {
      url: "https://sapi.kool5g.com/weappservice/was", //"http://192.168.2.2:81/weappservice/was", 
      wapUrl: "https://sapi.kool5g.com/weappservice/wap", // "http://192.168.2.2:81/weappservice/wap",

      // url: "http://192.168.2.2:81/weappservice/was",
      // wapUrl: "http://192.168.2.2:81/weappservice/wap",
      sessionid: '',
      fm: 'json',
      appKey: 'we_h5_1.0',
      v: '1.0'
    },
    screenWidth: 0,
    screenHeight: 0,
    loginState: 0,
    loginAccount: null,
    loginAccountList: null,
    needLoadMusic: 0
    // newsTitle:"处CP官网重要公告",
    // newsContent:"针对4月20日新华社发出的《语音社交软件乱像调查报告》中指出的色情交易、未成年人保护机制不完善、监管难度大等问题，我们处CP团队立即进行深刻的检讨反思，并在4月21日早上主动进行应用全网下架处理，应用进行全面核查，对指出的问题进行自查自纠、举一反三，成立应急小组迅速做出整改方案，全力配合相关部门进行监管监督，为未成年保驾护航，营造绿色健康的网络环境。 "
  },
  mutations: {
    inWhichPage(state, stark) {
      state.status = stark.page
    },
    setFullHeight(state, stark) {
      state.fullHeight = stark.height
    },
    setInitParam(state, document) {
      state.screenWidth = document.body.offsetWidth;
      state.screenHeight = document.body.offsetHeight;
    },
    setLoginState(state, value) {
      state.loginState = value;
    },
    setLoginAccount(state, account) {
      state.loginAccount = account;
    },
    setLoginAccountList(state, list) {
      state.loginAccountList = list;
    },
    setNeedLoadMusic(state, value) {
      state.needLoadMusic = value;
    }
  }
});
export default store



// WEBPACK FOOTER //
// ./src/store/store.js